// extracted by mini-css-extract-plugin
export default {"list-report-presence__container":"styles_list-report-presence__container__3B1aC"};